import { FeatureToggleServiceConfig, isOn, set } from 'feature-toggle-service';

export type LicenseToggleKey =
  'licenseSavedSearches'
  | 'licensePersonalLists'
  | 'licenseCustomShowcases'
  | 'licenseReadingHistory'
  | 'licenseDiscovery'
  | 'licenseDiscoverPlus'
  | 'licenseDiscoverPremium'
  | 'licenseDiscoverConsortia'
  | 'licenseCentralRequest';

export const customerFeatureToggles = [
  'DIS-27818_2023-07-01_advanced_search',
  'VE-2814_2023-09-30_announcements',
  'VE-3646_2023-12-31_staff_announcements',
  'DIS-30793_2024-04-27_auth_patron',
  'VE-3951_2024-04-30_discover-one-trust-banner',
  'VE-2769_2024-01-31_program-events',
  'DIS-31747_2024-06-01_patron_ui_maintenance_page',
  'DIS-31589',
  'VE-4281_2024-03-11_HomePageTheme',
  'DIS-28885_2024-06-31_syndetics_integration',
  'DIS-30364_2024-06-30_Social-Media-Share',
  'DIS-32351_2024-07-31_Syndetics-Links',
  'VE-4791_2024-07-31_pass_item_language',
  'VE-4775_2024-07-31_format_facet_search',
  'DIS-31554_2024-08-30_schedule_showcase',
  'VE-5253_2024-12-31_social-sharing',
  'DIS-32415_10-31-24_showcase-search',
  'VE-5395_2024-12-31_showcase_for_later',
  'VE-5396_2025-12-31_for_later_showcase_homepage',
  'VDIS-30375_2024-12-31_pickup-area',
  'VE-5143_2025-12-31_Account-Portal',
  'VE-5831_12-31-2025_portal-preferences',
  'VE-5143_2025-12-31_portal-checkouts-requests',
  'VE-5143_2025-12-31_portal-bills-fines',
  'VE-5143_2025-12-31_portal-bookings',
  'VE-5143_2025-12-31_portal-events',
  'VE-5143_2025-12-31_portal-bookmarks',
  'VE-5143_2025-12-31_portal-saved-searches',
  'VE-5143_2025-12-31_portal-recommendations',
  'VDIS-32043_2025-07-31_author-title-sort',
  'VDIS-32250_2025-12-31_rapido_interface',
  'VDIS-26915_2025-12-30_scope-count-display',
  'VDIS-33935_2025-07-31_new_instance_api',
  'VE-6813_2025-07-18_qr-code-nlb',
  'VDIS-29183_2025-08-30_citation-sharing',
  'VDIS-33338_2025-12-31_new_editions_UX_design',
  'VEGAENG-179_2025_12_31_pickup_areas_updates',
  'VEGAENG-190_2026-01-31_tab_based_search_metadata'
] as const;
export type CustomerFeatureToggleKey = typeof customerFeatureToggles[number];

// search for featureExample to find things you should set when adding feature flag
export type CombinedToggleKey = LicenseToggleKey | CustomerFeatureToggleKey;

export type CombinedToggleData = FeatureToggleServiceConfig & {
  [key in CombinedToggleKey]?: boolean;
};

export interface FeatureToggleServiceLibrary {
  isOn: typeof isOn;
  set: typeof set;
}
